import { Component, OnInit, TemplateRef } from '@angular/core';
import { DriverService } from '../driver.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {Router } from '@angular/router';
import {Sort} from '@angular/material/sort';
import { GenericServiceService } from '../../services/generic-service.service';

@Component({
  selector: 'app-drivers',
  templateUrl: './drivers.component.html',
  styleUrls: ['./drivers.component.scss']
})
export class DriversComponent implements OnInit {
  listOfAllDrivers: any = [];
  sortedData: any [];
  spin: boolean;
  modalRef: BsModalRef;
  cityId;
  countryList: any = [];
  batchList: any = [];
  cityList: any = [];
  cityObject: any = {};
  model: any = {};

  constructor(
    private driverService: DriverService,
    private router: Router,
    private modalService: BsModalService,
    private genericService: GenericServiceService
  ) { }

  sortData(sort: Sort) {
    const data = this.listOfAllDrivers.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }
    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'FirstName': return compare(a.FirstName, b.FirstName, isAsc);
        case 'DriverStatus': return compare(a.DriverStatus, b.DriverStatus, isAsc);

        default: return 0;
      }
    });
  }
  ngOnInit() {
    this.cityId = localStorage.getItem('cityId');
    this.getAllListedDrivers(this.cityId);
    this.getAllCountries();
    this.getAllBatches();

  }
  getAllBatches() {
    this.genericService.getAllBatches().subscribe(Response => {
      this.batchList = Response;
      console.log(this.batchList);
    });
  }
  getAllCountries() {
    this.genericService.getAllCountries().subscribe(Response => {
      this.countryList = Response;
    });
  }
  city(id) {
    this.genericService.getCitWithId(id).subscribe(Response => {
      this.cityList = Response;
    });
  }
  driverByCityId(cityID) {
    this.genericService.getCitWithCItyId(cityID).subscribe(Response => {
      if (Response) {
       this.cityObject = Response;
       localStorage.setItem('cityId', JSON.stringify(this.cityObject.Id));
       localStorage.setItem('cityName', JSON.stringify(this.cityObject.Name));
       this.getAllListedDrivers(cityID);
     }
   });
  }

  getAllListedDrivers(cityId) {
    this.driverService.getAllDriversByCityId(cityId).subscribe(Response => {
      this.listOfAllDrivers = Response;
      if (this.listOfAllDrivers == null) {
        this.spin = true;
      }
      this.sortedData = this.listOfAllDrivers.slice();
      this.spin = false;
    });
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {class: 'modal-sm'});
  }
  confirm(id): void {
    this.driverService.DeleteDriver(id).subscribe(Response => {
      this.getAllListedDrivers(this.cityId);
    });
    this.modalRef.hide();
  }

  decline(): void {
    this.modalRef.hide();
  }

  driverNavigation() {
    this.router.navigateByUrl('/drivers/add-driver');
  }
  gotoDriverinfo(Id) {
    this.router.navigateByUrl('/drivers/driverinfo/' + Id + '/profile');
  }
  changeBatches(batchId, driverId) {
    this.driverService.assignBatchToDriver(batchId, driverId).subscribe(Response => {
    });
  }

}
function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
